/** The project the shell is showing: the /p/:projectSlug param, else the last opened project, else the default project */

import { useParams } from 'react-router-dom'
import type { ProjectSummary } from '@agentwiki/shared'
import { useAppStore } from '../stores/app-store'
import { useProjects } from './use-projects'

export const DEFAULT_PROJECT_SLUG = 'default'

export function useCurrentProjectSlug(): string {
  const { projectSlug } = useParams<{ projectSlug: string }>()
  const lastProjectSlug = useAppStore((s) => s.lastProjectSlug)
  const { data: projects } = useProjects()
  if (projectSlug) return projectSlug
  // A remembered project may be gone, or belong to another account that used this browser
  if (projects) return resolveResumeProject(projects, lastProjectSlug)
  return lastProjectSlug ?? DEFAULT_PROJECT_SLUG
}

/** Where /p resumes: the remembered project if it still exists, else the default project, else the first one */
export function resolveResumeProject(projects: ProjectSummary[], ...remembered: (string | null | undefined)[]): string {
  for (const slug of remembered) {
    if (slug && projects.some((p) => p.slug === slug)) return slug
  }
  return (projects.find((p) => p.isDefault) ?? projects[0])?.slug ?? DEFAULT_PROJECT_SLUG
}
